<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="结款方名称" :value="1"></el-option>
							<el-option label="结款方用户ID" :value="2"></el-option>
							<el-option label="滞留款名称" :value="3"></el-option>
							<el-option label="滞留款ID" :value="4"></el-option>
							<el-option label="关联演出名称" :value="5"></el-option>
							<el-option label="关联演出 ID" :value="6"></el-option>
							<el-option label="关联结算单 ID" :value="7"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.status" placeholder="请选择" size="small">
						<el-option label="仅看滞留中的" :value="1"></el-option>
						<el-option label="仅看已关联演出的" :value="2"></el-option>
						<el-option label="仅看已结款的" :value="3"></el-option>
						<el-option label="不限制状态" :value="-1"></el-option>
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
					<div class="clearfix timeType">
						<el-input class="input-with-select fl" size="small">
							<el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
								<el-option label="创建时间" :value="1"></el-option>
								<el-option label="结款时间" :value="2"></el-option>
							</el-select>
						</el-input>
						<el-date-picker v-model="time" type="datetimerange" start-placeholder="开始日期"
							end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" :clearable="false" align="right" unlink-panels>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button type="primary" icon="el-icon-plus" @click="$refs.details.show()" size="small"
				v-if="$utils.have('/retention/payment/save')">新建滞留单</el-button>
			<el-button type="primary" size="small" @click="exportData" :loading="exportDataLoading"
				icon="el-icon-download">导出</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>

				<el-table-column prop="id" label="滞留款ID"></el-table-column>
				<el-table-column prop="title" label="滞留款标题" show-overflow-tooltip :min-width="250"></el-table-column>
				<el-table-column label="结款方" show-overflow-tooltip :min-width="200">
					<template slot-scope="{row} = scope">
						{{row.receivableUserType}}-{{row.receivableUserName}}（{{row.receivableUserId}}）
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="滞留款金额" :min-width="100"></el-table-column>
				<el-table-column prop="statusView" label="款项状态"></el-table-column>
				<el-table-column prop="relActivityId" label="演出ID"></el-table-column>
				<el-table-column prop="relActivityTitle" label="演出名称" show-overflow-tooltip
					:min-width="150"></el-table-column>
				<el-table-column prop="relActivityStatusView" label="演出状态"></el-table-column>
				<el-table-column prop="receivableId" label="结款单ID"></el-table-column>
				<el-table-column prop="receivableStatus" label="结款单状态" :min-width="100"></el-table-column>
				<el-table-column prop="remark" label="款项备注" show-overflow-tooltip :min-width="250"></el-table-column>
				<el-table-column prop="settlementTime" label="结款时间" :min-width="150"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" :min-width="150"></el-table-column>
				<el-table-column prop="createUserName" label="创建人"></el-table-column>
				<el-table-column fixed="right" label="操作" :width="150">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="$refs.details.show(scope.row)">
							<span v-if="scope.row.status === 1" class="el-icon-edit"> 修改</span>
							<span v-if="scope.row.status === 2 || scope.row.status === 3 " class="el-icon-view"> 查看</span>
						</el-button>
						<el-button type="text" size="small" @click="unbind(scope.row)">
							<span v-if="scope.row.statusView === '已关联演出' ">解除关联</span>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<Details ref="details" @onUpdate="getDataList"></Details>
	</div>
</template>

<script>
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi.js';
	import Details from '../components/details.vue'
	const defaultParams = {
		pageNo: 1,
		searchType: 1,
		searchValue: '',
		timeType: 1,
		beginTime: '',
		endTime: '',
		status: -1
	}

	export default {
		components: {
			Details
		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || '',
					timeType: parseInt(this.$route.query.timeType || 1),
					beginTime: this.$route.query.beginTime || '',
					endTime: this.$route.query.endTime || '',
					status: parseInt(this.$route.query.status || -1),
				},
				listLoading: true,
				time: [],
				exportDataLoading: false,
				filter: null,
			}
		},		
		mounted() {
			this.getDataList();
		},
		methods: {

			//获取列表
			getDataList() {
				this.listLoading = true;
				this.params = {
					...this.params,
					beginTime: this.time && this.time[0] || '',
					endTime: this.time && this.time[1] || ''
				}
				this.$request({
						url: '/retention/payment/list',
						method: "POST",
						data: this.params,
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];

						} else {
							this.data = null;
							this.dataList = null;
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.time = []
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
					startTime: this.time && this.time[0] || '',
					endTime: this.time && this.time[1] || ''
				};
				this.getDataList();
			},
			unbind(data) {
				const _msg =
					`<div>滞留款已经绑定到演出：<span class="color-danger">${data.relActivityId}  ${data.relActivityTitle}</span><p>解除关联，将从该演出的"额外技术服务费"去掉这笔款项，确定吗？</p></div>`;
				this.$confirm(_msg, '解除关联该演出', {					
					center: false,
					dangerouslyUseHTMLString: true,
					closeOnClickModal: false
				}).then(() => {
					this.$request({
							url: "/retention/payment/unLink",
							method: "POST",
							params: {
								id: parseInt(data.id)
							},
						})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success("操作成功");
								this.getDataList()
							} else {
								this.$message.error(msg || "请求失败");
							}
						})
						.catch(() => {
							this.$message.error("请求错误");
						})
				}).catch(() => {

				})
			},
			// 导出
			async exportData() {
				this.exportDataLoading = true;
				let filePath;
				const res = await this.$request({
						url: '/retention/payment/export',
						method: "POST",
						data: this.params,
					})
					.catch(err => {
						this.$message({
							message: err.message,
							type: 'error'
						});
					})
				const {
					state,
					msg,
					result
				} = res.data;
				if (state == 1 && result) {

					filePath = result.url;
				} else {
					this.exportDataLoading = false;
					return this.$message.error(msg || '下载失败');
				}

				await downloadFileTmp(filePath, result.fileName);
				this.exportDataLoading = false;

			}


		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-table__row expanded {
		div {
			line-height: 30px;
		}
	}
</style>